import React from "react";
import ViewListIcon from "@mui/icons-material/ViewList";
//import UploadFileIcon from "@mui/icons-material/UploadFile";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
//import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SummarizeIcon from "@mui/icons-material/Summarize";
import CIcon from "@coreui/icons-react";
const BootClass = "mr-2 ml-2";
const BootClassDashboard = "c-sidebar-nav-icon";

export const _navBidder = [
  {
    _tag: "CSidebarNavItem",
    name: "Dashboard",
    to: "/",
    icon: (
      <CIcon
        name="cil-speedometer"
        className={BootClassDashboard}
        style={{ marginLeft: "-0.35rem", marginRight: "-0.75rem" }}
      />
    ),
  },
  {
    _tag: "CSidebarNavItem",
    name: "Lot List",
    to: "/lotlist",
    icon: <ViewListIcon className={BootClass} />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Lot Transferred List",
    to: "/transferlotlist",
    icon: <ViewListIcon className={BootClass} />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Invoice List",
    to: "/invoice",
    icon: <ViewListIcon className={BootClass} />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Support Ticket",
    onClick: () => window.open("http://202.131.108.246:4019", "_blank"), // Opens in a new tab
    icon: <ViewListIcon className={BootClass} />,
  },
];

export const _navDfo = [
  // {
  //   _tag: "CSidebarNavItem",
  //   name: "Bidder List",
  //   to: "/bidderlist",
  //   icon: <ViewListIcon className={BootClass} />,
  //   className: "cNavRow",
  // },

  {
    _tag: "CSidebarNavItem",
    name: "Lot List",
    to: "/lotlist",
    icon: <ViewListIcon className={BootClass} />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Lot Transferred List",
    to: "/transferlotlist",
    icon: <ViewListIcon className={BootClass} />,
  },

  // {
  //   _tag: "CSidebarNavDropdown",
  //   name: "Data List",
  //   route: "/datalist",
  //   icon: "cil-grid",
  //   _children: [
  //     {
  //       _tag: "CSidebarNavItem",
  //       name: "Create",
  //       to: "/datalist/create",
  //     },
  //   ],
  // },

  // {
  //   _tag: "CSidebarNavItem",
  //   name: "User List",
  //   to: "/userlist",
  //   icon: <ViewListIcon className={BootClass} />,
  // },
  // {
  //   _tag: "CSidebarNavItem",
  //   name: "Circle List",
  //   to: "/circlelist",
  //   icon: <ViewListIcon className={BootClass} />,
  // },
  // {
  //   _tag: "CSidebarNavItem",
  //   name: "District Union List",
  //   to: "/districtlilst",
  //   icon: <ViewListIcon className={BootClass} />,
  // },
  {
    _tag: "CSidebarNavItem",
    name: "Tender List",
    to: "/tenderlist",
    icon: <ViewListIcon className={BootClass} />,
  },
  // {
  //   _tag: "CSidebarNavItem",
  //   name: "Bank Guarantee List",
  //   to: "/bankguaranteelist",
  //   icon: <ViewListIcon className={BootClass} />,
  // },
  // {
  //   _tag: "CSidebarNavItem",
  //   name: "Transfered Lot",
  //   to: "/transferlotapprovals",
  //   icon: <ViewListIcon className={BootClass} />,
  // },
  // {
  //   _tag: "CSidebarNavItem",
  //   name: "Adhoc Payments List",
  //   to: "/adhocpaymentlist",
  //   icon: <ViewListIcon className={BootClass} />,
  // },
  // {
  //   _tag: "CSidebarNavItem",
  //   name: "Payment Details",
  //   to: "/paymentdetails",
  //   icon: <MonetizationOnIcon className={BootClass} />,
  // },
  {
    _tag: "CSidebarNavItem",
    name: "Online Payment Report",
    to: "/onlinepaymentreport",
    icon: <SummarizeIcon className={BootClass} />,
  },
   {
    _tag: "CSidebarNavItem",
    name: "Payment Received - Lot Wise Details",
    to: "/prlotdetailreport",
    icon: <SummarizeIcon className={BootClass} />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "BG Payment Report",
    to: "/bgpaymentreport",
    icon: <SummarizeIcon className={BootClass} />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Cheque Payment Report",
    to: "/chequepaymentreport",
    icon: <SummarizeIcon className={BootClass} />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Access Benefit Sharing BG List",
    to: "/ABSbankguaranteelist",
    icon: <ViewListIcon className={BootClass} />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Download Paridhan Aadesh",
    to: "/DownloadParidhanAadesh",
    icon: <ViewListIcon className={BootClass} />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "GoDown Fees Extension",
    to: "/GoDownFeesExtension/List",
    icon: <ViewListIcon className={BootClass} />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Cheque Clearing",
    to: "/ChequeClearing/List",
    icon: <ViewListIcon className={BootClass} />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Adjustment Payment",
    to: "/lot/adhocpayment",
    icon: <ViewListIcon className={BootClass} />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Invoice List",
    to: "/invoice",
    icon: <ViewListIcon className={BootClass} />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Support Ticket",
    onClick: () => window.open("http://202.131.108.246:4019", "_blank"), // Opens in a new tab
    icon: <ViewListIcon className={BootClass} />,
  },
];

export const _navCfo = [
  // {
  //   _tag: "CSidebarNavItem",
  //   name: "Bidder List",
  //   to: "/bidderlist",
  //   icon: <ViewListIcon className={BootClass} />,
  //   className: "cNavRow",
  // },
  {
    _tag: "CSidebarNavItem",
    name: "Lot List",
    to: "/lotlist",
    icon: <ViewListIcon className={BootClass} />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Lot Transferred List",
    to: "/transferlotlist",
    icon: <ViewListIcon className={BootClass} />,
  },

  // {
  //   _tag: "CSidebarNavItem",
  //   name: "Adhoc Payments List",
  //   to: "/adhocpaymentlist",
  //   icon: <ViewListIcon className={BootClass} />,
  // },
  // {
  //   _tag: "CSidebarNavItem",
  //   name: "Payment Details",
  //   to: "/paymentdetails",
  //   icon: <MonetizationOnIcon className={BootClass} />,
  // },

  // {
  //   _tag: "CSidebarNavDropdown",
  //   name: "Data List",
  //   route: "/datalist",
  //   icon: "cil-grid",
  //   _children: [
  //     {
  //       _tag: "CSidebarNavItem",
  //       name: "Create",
  //       to: "/datalist/create",
  //     },
  //   ],
  // },

  // {
  //   _tag: "CSidebarNavItem",
  //   name: "User List",
  //   to: "/userlist",
  //   icon: <ViewListIcon className={BootClass} />,
  // },
  // {
  //   _tag: "CSidebarNavItem",
  //   name: "Circle List",
  //   to: "/circlelist",
  //   icon: <ViewListIcon className={BootClass} />,
  // },
  // {
  //   _tag: "CSidebarNavItem",
  //   name: "District Union List",
  //   to: "/districtlilst",
  //   icon: <ViewListIcon className={BootClass} />,
  // },
  {
    _tag: "CSidebarNavItem",
    name: "Tender List",
    to: "/tenderlist",
    icon: <ViewListIcon className={BootClass} />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Bank Guarantee Payment",
    to: "/bankguaranteelist",
    icon: <ViewListIcon className={BootClass} />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Pending Agreement Extend List",
    to: "/PendingAgreementextendListCFO",
    icon: <ViewListIcon className={BootClass} />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Lot Transfer Approval",
    to: "/transferlotapprovals",
    icon: <ViewListIcon className={BootClass} />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Online Payment Report",
    to: "/onlinepaymentreport",
    icon: <SummarizeIcon className={BootClass} />,
  },
     {
    _tag: "CSidebarNavItem",
    name: "Payment Received - Lot Wise Details",
    to: "/prlotdetailreport",
    icon: <SummarizeIcon className={BootClass} />,
  },
    {
    _tag: "CSidebarNavItem",
    name: "Payment Received - District Wise Details",
    to: "/prdistrictdetailreport",
    icon: <SummarizeIcon className={BootClass} />,
  },

  
  {
    _tag: "CSidebarNavItem",
    name: "BG Payment Report",
    to: "/bgpaymentreport",
    icon: <SummarizeIcon className={BootClass} />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Cheque Payment Report",
    to: "/chequepaymentreport",
    icon: <SummarizeIcon className={BootClass} />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Cheque Payment List",
    to: "/emdbgpaymentList",
    icon: <MonetizationOnIcon className={BootClass} />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Support Ticket",
    onClick: () => window.open("http://202.131.108.246:4019", "_blank"), // Opens in a new tab
    icon: <ViewListIcon className={BootClass} />,
  },
];
// export const _navCgmf = [
//   {
//     _tag: "CSidebarNavItem",
//     name: "CGMFP Federation - HO Officer",
//     to: "/cgmflist",
//     icon: <ViewListIcon className={BootClass} />,
//   },
//   {
//     _tag: "CSidebarNavItem",
//     name: "Circle Forest Officer",
//     to: "/cfolist",
//     icon: <ViewListIcon className={BootClass} />,
//   },
//   {
//     _tag: "CSidebarNavItem",
//     name: "District Union Forest Officer",
//     to: "/dfolist",
//     icon: <ViewListIcon className={BootClass} />,
//   },
//   {
//     _tag: "CSidebarNavItem",
//     name: "Bidder List",
//     to: "/bidderlist",
//     icon: <ViewListIcon className={BootClass} />,
//     className: "cNavRow",
//   },
//   {
//     _tag: "CSidebarNavItem",
//     name: "Lot Selection",
//     to: "/lotlist",
//     icon: <ViewListIcon className={BootClass} />,
//   },
//   {
//     _tag: "CSidebarNavItem",
//     name: "Lot List",
//     to: "/lotdetails",
//     icon: <ViewListIcon className={BootClass} />,
//   },
//   // {
//   //   _tag: "CSidebarNavDropdown",
//   //   name: "Data List",
//   //   route: "/datalist",
//   //   icon: "cil-grid",
//   //   _children: [
//   //     {
//   //       _tag: "CSidebarNavItem",
//   //       name: "Create",
//   //       to: "/datalist/create",
//   //     },
//   //   ],
//   // },

//   {
//     _tag: "CSidebarNavItem",
//     name: "Circle List",
//     to: "/circlelist",
//     icon: <ViewListIcon className={BootClass} />,
//   },
//   {
//     _tag: "CSidebarNavItem",
//     name: "District Union List",
//     to: "/districtlilst",
//     icon: <ViewListIcon className={BootClass} />,
//   },
//   {
//     _tag: "CSidebarNavItem",
//     name: "Tender List",
//     to: "/tenderlist",
//     icon: <ViewListIcon className={BootClass} />,
//   },
//   {
//     _tag: "CSidebarNavItem",
//     name: "Bank Guarantee List",
//     to: "/bankguaranteelist",
//     icon: <ViewListIcon className={BootClass} />,
//   },
//   {
//     _tag: "CSidebarNavItem",
//     name: "User List",
//     to: "/userlist",
//     icon: <AccountCircleIcon className={BootClass} />,
//   },
//   {
//     _tag: "CSidebarNavItem",
//     name: "Pending Users List",
//     to: "/pendingapprovals",
//     icon: <ViewListIcon className={BootClass} />,
//   },
//   {
//     _tag: "CSidebarNavItem",
//     name: "Transferred Lot List",
//     to: "/transferlotlist",
//     icon: <ViewListIcon className={BootClass} />,
//   },

//   {
//     _tag: "CSidebarNavItem",
//     name: "Offline Payment Requests List",
//     to: "/offlinepaymentslist",
//     icon: <ViewListIcon className={BootClass} />,
//   },
//   {
//     _tag: "CSidebarNavItem",
//     name: "Lot Transfer Request",
//     to: "/transfertoholotapprovals",
//     icon: <ViewListIcon className={BootClass} />,
//   },

//   // {
//   //   _tag: "CSidebarNavItem",
//   //   name: "Payment Details",
//   //   to: "/paymentdetails",
//   //   icon: <MonetizationOnIcon className={BootClass} />,
//   // },
//   {
//     _tag: "CSidebarNavItem",
//     name: "Import Lots",
//     to: "/lotexcelsheet",
//     icon: <UploadFileIcon className={BootClass} />,
//   },
//   {
//     _tag: "CSidebarNavItem",
//     name: "Import Lot Actual Quantity",
//     to: "/importactualquantity",
//     icon: <UploadFileIcon className={BootClass} />,
//   },
//   {
//     _tag: "CSidebarNavItem",
//     name: "Import Bidders",
//     to: "/importbidderexcel",
//     icon: <UploadFileIcon className={BootClass} />,
//   },
//   {
//     _tag: "CSidebarNavItem",
//     name: "Adhoc Payment",
//     to: "/adhocpayment",
//     icon: <MonetizationOnIcon className={BootClass} />,
//   },
//   // {
//   //   _tag: "CSidebarNavItem",
//   //   name: "Adhoc Payments List",
//   //   to: "/adhocpaymentlist",
//   //   icon: <ViewListIcon className={BootClass} />,
//   // },
//   {
//     _tag: "CSidebarNavItem",
//     name: "Complete Lot Details",
//     to: "/completelotdetails",
//     icon: <ViewListIcon className={BootClass} />,
//   },
//   {
//     _tag: "CSidebarNavItem",
//     name: "Payment Refund Status Report",
//     to: "/refundreport",
//     icon: <SummarizeIcon className={BootClass} />,
//   },
//   {
//     _tag: "CSidebarNavItem",
//     name: "Income Tax Consession Request",
//     to: "/incometaxconsessionrequest",
//     icon: <SummarizeIcon className={BootClass} />,
//   },
//   {
//     _tag: "CSidebarNavItem",
//     name: "Online Payment Report",
//     to: "/onlinepaymentreport",
//     icon: <SummarizeIcon className={BootClass} />,
//   },
//   {
//     _tag: "CSidebarNavItem",
//     name: "BG Payment Report",
//     to: "/bgpaymentreport",
//     icon: <SummarizeIcon className={BootClass} />,
//   },
//   {
//     _tag: "CSidebarNavItem",
//     name: "Cheque Payment Report",
//     to: "/chequepaymentreport",
//     icon: <SummarizeIcon className={BootClass} />,
//   },
//   {
//     _tag: "CSidebarNavItem",
//     name: "MIS Report",
//     to: "/misreport",
//     icon: <SummarizeIcon className={BootClass} />,
//   },
//   {
//     _tag: "CSidebarNavItem",
//     name: "Pending Agreement Extend List",
//     to: "/PendingAgreementextendListHO",
//     icon: <ViewListIcon className={BootClass} />,
//   },
//   {
//     _tag: "CSidebarNavItem",
//     name: "Cheque Payment List",
//     to: "/emdbgpaymentList",
//     icon: <MonetizationOnIcon className={BootClass} />,
//   },

//   {
//     _tag: "CSidebarNavDropdown",
//     name: "Report",
//     route: "/base",
//     icon: "cil-puzzle",
//     _children: [
//       {
//         _tag: "CSidebarNavItem",
//         name: "Lot Wise",
//         to: "/report/pbsms/lot",
//       },
//       {
//         _tag: "CSidebarNavItem",
//         name: "Cricle Wise",
//         to: "/report/pbsms/cricle",
//       },
//       {
//         _tag: "CSidebarNavItem",
//         name: "District Wise",
//         to: "/report/pbsms/district",
//       },
//       {
//         _tag: "CSidebarNavItem",
//         name: "Payment Received - Lot Wise",
//         to: "/report/pbsms/prlot",
//       },
//       {
//         _tag: "CSidebarNavItem",
//         name: "Payment Received - Cricle Wise",
//         to: "/report/pbsms/prcricle",
//       },
//       {
//         _tag: "CSidebarNavItem",
//         name: "Payment Received - District Wise",
//         to: "/report/pbsms/prdistrict",
//       },
//       {
//         _tag: "CSidebarNavItem",
//         name: "Transfered Lot List",
//         to: "/report/pbsms/transferedlot",
//       },
//       {
//         _tag: "CSidebarNavItem",
//         name: "Income Tax Consession Request",
//         to: "/report/pbsms/itconsessionrequest",
//       },
//       {
//         _tag: "CSidebarNavItem",
//         name: "Agreement Extension",
//         to: "/report/pbsms/agreementextension",
//       },
//       {
//         _tag: "CSidebarNavItem",
//         name: "Bank Gaurantee Received",
//         to: "/report/pbsms/bgreceived",
//       },
//       {
//         _tag: "CSidebarNavItem",
//         name: "Agreement Status",
//         to: "/report/pbsms/agreementstatus",
//       },
//     ],
//   },
// ];

// export default _navCgmf;
